import { render, staticRenderFns } from "./UidAuth.vue?vue&type=template&id=e4ef0958&scoped=true&"
import script from "./UidAuth.vue?vue&type=script&lang=js&"
export * from "./UidAuth.vue?vue&type=script&lang=js&"
import style0 from "./UidAuth.vue?vue&type=style&index=0&id=e4ef0958&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ef0958",
  null
  
)

export default component.exports